<p-drawer [(visible)]="visible" (onHide)="onDrawerHide()" position="right" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
  styleClass="layout-profile-sidebar w-full sm:w-25rem">
  <ng-template #header>
      <div class="flex items-center gap-2">
      <div class="mt-3">
        <p-avatar label="{{name}}" size="large" shape="circle"
          [style]="{ 'background-color': '#9c27b0', color: '#ffffff', 'border-radius': '50%' }"></p-avatar>
      </div>
      </div>
  </ng-template>

  <div class="flex flex-column mx-auto md:mx-0">
    <span class="mb-2 font-semibold title-label">Welcome</span>
    <span class="text-color-secondary font-medium mb-5 title-label">{{user?.first_name}} {{user?.last_name}}</span>

    <ul class="list-none m-0 p-0">
      <li routerLink="/profile/account">
        <a
          class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
          <span>
            <i class="pi pi-user text-xl text-primary"></i>
          </span>
          <div class="ml-3">
            <span class="mb-2 font-semibold title-label">Profile</span>
            <p class="text-color-secondary m-0 subtitle-label">View or Edit Profile.</p>
          </div>
        </a>
      </li>
      <li (click)="logout()">
        <a
          class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
          <span>
            <i class="pi pi-power-off text-xl text-red-500"></i>
          </span>
          <div class="ml-3">
            <span class="mb-2 font-semibold title-label">Sign Out</span>
            <p class="text-color-secondary m-0 subtitle-label">Sign out from your Account.</p>
          </div>
        </a>
      </li>
    </ul>
  </div>

  <div class="flex flex-column mt-5 mx-auto md:mx-0">
    <span class="mb-1 font-semibold title-label">Knowledge Base</span>
    <span class="text-color-secondary mb-2 subtitle-label">Learn Cogwheel Analytics</span>

    <ul class="list-none m-0 p-0">
      <li (click)="openKnowledgeBase()">
        <a
          class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
          <span>
            <i class="pi pi-file-word text-xl text-primary"></i>
          </span>
          <div class="ml-3">
            <span class="mb-2 font-semibold title-label">Knowledge Base</span>
          </div>
        </a>
      </li>

    </ul>
  </div>

  <div class="flex flex-column mt-5 mx-auto md:mx-0">
    <span class="mb-1 font-semibold title-label">Hotel Request And Feedback</span>
    <span class="text-color-secondary mb-2 subtitle-label">Add, Remove and Support Hotel Request and give feedback.</span>

    <ul class="list-none m-0 p-0">
      <li (click)="hotelRequestAndFeedback(EHotelRequestType.Add)">
        <a
          class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
          <span>
            <i class="pi pi-plus-circle text-xl text-green-500"></i>
          </span>
          <div class="ml-3">
            <span class="mb-2 font-semibold title-label">Add Hotel Request</span>
          </div>
        </a>
      </li>
      <li (click)="hotelRequestAndFeedback(EHotelRequestType.Remove)">
        <a
          class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
          <span>
            <i class="pi pi-minus-circle text-xl text-red-500"></i>
          </span>
          <div class="ml-3">
            <span class="mb-2 font-semibold title-label">Remove Hotel Request</span>
          </div>
        </a>
      </li>
      <li (click)="hotelRequestAndFeedback(EHotelRequestType.Support)">
        <a
          class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
          <span>
            <i class="pi pi-question-circle text-xl text-blue-500"></i>
          </span>
          <div class="ml-3">
            <span class="mb-2 font-semibold title-label">Support Request</span>
          </div>
        </a>
      </li>
      <li (click)="hotelRequestAndFeedback(EHotelRequestType.Feedback)">
        <a
          class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
          <span>
            <i class="pi pi-comment text-xl text-yellow-500"></i>
          </span>
          <div class="ml-3">
            <span class="mb-2 font-semibold title-label">Feedback</span>
          </div>
        </a>
      </li>
    </ul>
  </div>

  <div *ngIf="isSuperAdmin" class="flex flex-column mt-5 mx-auto md:mx-0">
    <span class="mb-1 font-semibold title-label">Admin External Service</span>
    <span class="text-color-secondary mb-2 subtitle-label">Access admin panel tools.</span>
    <ul class="list-none m-0 p-0">
      <li (click)="openExternalAdminPanel()">
        <a
          class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
          <span>
            <i class="pi pi-external-link text-xl text-blue-500"></i>
          </span>
          <div class="ml-3">
            <span class="mb-2 font-semibold title-label">External Admin Panel</span>
            <p class="text-color-secondary m-0 subtitle-label">Open external admin service.</p>
          </div>
        </a>
      </li>
    </ul>
  </div>

  <div class="flex flex-column mt-5 mx-auto md:mx-0">
    <div class="mb-3">
      <p class="mb-0 title-label">Client Success Manager:</p>
      <span class="text-sm"><a href="mailto:pooja@cogwheelanalytics.com">Pooja&#64;CogwheelAnalytics.com</a></span>
    </div>

    <div class="mb-3">
      <p class="mb-0 title-label">Accounting:</p>
      <p class="text-sm"><a href="mailto:cccounting@cogwheelmarketing.com">Accounting&#64;CogwheelMarketing.com</a></p>
    </div>
  </div>

</p-drawer>
